import { render, staticRenderFns } from "./Pre.vue?vue&type=template&id=3dcf5a83&scoped=true"
import script from "./Pre.vue?vue&type=script&lang=js"
export * from "./Pre.vue?vue&type=script&lang=js"
import style0 from "./Pre.vue?vue&type=style&index=0&id=3dcf5a83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf5a83",
  null
  
)

export default component.exports